module.exports = __webpack_public_path__ + "static/media/fd-mobil-ok.e1c1bb6b.png";